import type { IImpressionUIElement } from '@schibsted/pulse-sdk';
import type { PulseContextInputParams } from '../../../types/index.js';

export interface UIElementViewAttributes {
  'data-track-event': string;
  'data-track-object-type': 'UIElement';
}

export const buildImpressionUIElementAttributes = (
  event: PulseContextInputParams<IImpressionUIElement>,
): UIElementViewAttributes => ({
  'data-track-event': JSON.stringify(event),
  'data-track-object-type': 'UIElement',
});
